import { useStateMachine } from "little-state-machine";
import { useCurrencyState } from "@hooks/useCurrency";
import { useCheckoutDispatch } from "@hooks/useCheckout";
import { trackEvent } from "@lib/track-event";
import { updateAction } from "../updateAction";
import { resolveVariant } from "../../BundleView/lib/resolve-variant";
import { getVariantOptions, getSize, getNavigation } from "../../lib/product-utils";
import formatVariantPrice from "../../lib/format-variant-price";

export function useForm() {
  const { currency } = useCurrencyState();
  const { addCartItem } = useCheckoutDispatch();
  const { actions, state } = useStateMachine({ updateAction });

  const handleSubmit = (event) => {
    event.preventDefault();
    addCartItem(state[`variant`], 1, state[`productGroup`]);
  };

  let variants = null;
  let product = null;
  product = state[`product`];
  variants = product.productReferenceV2.variants;
  let variant = variants[0];

  if (state[`variant`]) {
    variant = state[`variant`];
  }

  let { price, compareAtPrice, amount } = formatVariantPrice(variant, currency, 1);

  let finalSale = [];
  finalSale = state[`productGroup`].shopifyProducts
    .filter(({ productReferenceV2 }) => productReferenceV2.tags.find((tag) => tag === "final-sale"))
    .map(({ productReferenceV2 }) => productReferenceV2.id);

  const navigation = getNavigation(state[`productGroup`], product, finalSale);
  const options = getVariantOptions(variants, variant);

  const handleOptionChange = (selected) => {
    const size = selected.value;
    const option = selected.option;
    const openBox = selected.isOpenBox;
    const updatedVariant = resolveVariant(variants, { size, option, openBox });
    const updatedState = {};
    updatedState[`variant`] = updatedVariant;
    actions.updateAction(updatedState);
    trackEvent("customize_product", {
      category: "size",
      value: size,
      variant: updatedVariant,
    });
  };

  const handleNavigationChange = (e) => {
    const color = e.labelText;
    const newProduct = state[`productGroup`].shopifyProducts.find(
      (p) => p.productReferenceV2.id === e.id
    );
    const updatedVariant = resolveVariant(newProduct.productReferenceV2.variants, {
      size: getSize(variant),
      option: "size",
    });

    const updatedState = {};
    updatedState[`product`] = newProduct;
    updatedState[`variant`] = updatedVariant;
    actions.updateAction(updatedState);
    trackEvent("customize_product", { category: "color", value: color, variant: updatedVariant });
  };

  return {
    product,
    price,
    compareAtPrice,
    amount,
    navigation,
    options,
    finalSale,
    handleOptionChange,
    handleNavigationChange,
    handleSubmit,
  };
}
